import { Link as RouterLink } from 'react-router-dom';
import { lighten } from '@mui/material';

import { Button } from '@occc/ui-design-system';

type SidebarSubItemProps = {
  isActive: boolean;
  title: string;
  linkTo: string;
};

export const SidebarSubItem = ({ title, isActive, linkTo }: SidebarSubItemProps) => {
  //
  return (
    <Button
      data-testid={title}
      component={RouterLink}
      to={linkTo}
      sx={(theme) => ({
        display: 'flex',
        minHeight: '40px',
        pl: 2,
        textTransform: 'none',
        letterSpacing: 0,
        justifyContent: 'start',
        borderRadius: 2,
        fontSize: '1.4rem',
        fontWeight: isActive ? 700 : 400,
        color: isActive ? 'primary.main' : 'text.secondary',
        background: isActive ? lighten(theme.palette.primary.main, 0.9) : null,
        lineHeight: 1.2,
        alignItems: 'center',
        '&:hover': {
          background: isActive
            ? lighten(theme.palette.primary.main, 0.9)
            : lighten(theme.palette.background.default, 0.5),
          cursor: isActive ? 'default' : 'pointer',
        },
      })}
      fullWidth
    >
      {title}
    </Button>
  );
};
